// Mirrors the Edit*ContextProvider files in modellingtool; keep this list in sync with them.
const EDITABLE_ELEMENT_TYPES = new Set([
  "kea.BPMNActivity",
  "kea.BPMNEvent",
  "kea.BPMNSwimlane",
  "kea.Circle",
  "kea.EPKEvent",
  "kea.EPKFunction",
  "kea.EPKInformationObject",
  "kea.EPKOrganizationalUnit",
  "kea.Ellipse",
  "kea.PNMarker",
  "kea.Polygon",
  "kea.Rectangle",
  "kea.UMLActivityNode",
  "kea.UMLClass",
  "kea.UMLComplexState",
  "kea.UMLLifeLine",
  "kea.UMLReceiveSymbol",
  "kea.UMLSendSymbol",
  "kea.UMLSimpleState",
  "kea.UMLStateInvariant",
]);

export const isEditableElement = (cell: joint.dia.Cell): boolean => EDITABLE_ELEMENT_TYPES.has(cell.get("type"));

// The Petri net marker carries no name in the notation; F2 and the context menu still reach it.
const NOT_LABELLED_ON_DROP = new Set(["kea.PNMarker"]);

export const isLabelledOnDrop = (cell: joint.dia.Cell): boolean =>
  isEditableElement(cell) && !NOT_LABELLED_ON_DROP.has(cell.get("type"));

const LABEL_ONLY_TYPES = new Set([
  "kea.BPMNEvent",
  "kea.EPKEvent",
  "kea.EPKFunction",
  "kea.EPKInformationObject",
  "kea.EPKOrganizationalUnit",
  "kea.PNMarker",
  "kea.UMLActivityNode",
  "kea.UMLReceiveSymbol",
  "kea.UMLSendSymbol",
  "kea.UMLSimpleState",
  "kea.UMLStateInvariant",
]);

export const isLabelOnlyElement = (cell: joint.dia.Cell): boolean => LABEL_ONLY_TYPES.has(cell.get("type"));
